define("ExtenralVendor.Inventory.CheckoutModule", [
  "Wizard.Module",
  "Utils",
  "SDB.SDBLocations.Model",
  "Handlebars",
], function (WizardModule, Utils, SDBLocationsModel, Handlebars) {
  return WizardModule.extend({
    className: "ExtenralVendor.Inventory.CheckoutModule",
    initialize: function initialize() {
      WizardModule.prototype.initialize.apply(this, arguments);
      this.template = this.options.template;
      this.inventoryModel = this.options.ExternalInventoryModel;
      var LocationsModel = this.options.LocationsModel;
      LocationsModel.set("locationChanged", false);
      this.title = "Estimated Ship Date";
      this.env = this.wizard.application.getComponent("Environment");
      var self = this;
      LocationsModel.on({
        "change:locationChanged": function changeLocationChanged(changed) {
          if (changed) {
            self.render();
            LocationsModel.set("locationChanged", false);
          }
        },
      });
    },
    // @returns {String} Title - the title assigned to this module
    getTitle: function getTitle() {
      return _(this.title).isFunction() ? this.title() : this.title || "";
    },
    // @returns {Object} - A custom object with the line ID and quantity of the item with the biggest quantity
    getMaxQty: function getMaxQty() {
      var lines = this.model.get("lines");
      var maxQtyLine = lines.max("quantity");
      return {
        line_id: maxQtyLine.get("intenralid"),
        quantity: maxQtyLine.get("quantity"),
      };
    },
    // @returns {String} estimatedTime - The estimated time for the item with the biggest quantity
    getEstimatedTime: function getEstimatedTime() {
      var options = this.model.get("options");
      var inventoryData = JSON.parse(
        options.custbody_sdb_store_ext_inv_data || "{}"
      );
      if (inventoryData == {} || Object.keys(inventoryData).length == 0)
        return "";
      var estimatedTime = "";
      var estimateValue = -1;

      var inventoryValues = Object.keys(inventoryData).map(function (e) {
        return inventoryData[e];
      });
      for (var j = 0; j < inventoryValues.length; j++) {
        var inventory = inventoryValues[j];
        for (var i = 0; i < inventory.length; i++) {
          var data = inventory[i];
          if (!data.shipping_eta) continue;
          if (data.used_stock == 0) continue;
          if (estimateValue <= data.shipping_eta.value) {
            estimatedTime = data.shipping_eta.text;
            estimateValue = data.shipping_eta.value;
          }
        }
      }

      var intData = JSON.parse(options.custbody_sdb_store_int_inv_data || "{}");
      if (intData != {} && Object.keys(intData).length != 0) {
        var intValues = Object.keys(intData).map(function (e) {
          return intData[e];
        });
        for (var j = 0; j < intValues.length; j++) {
          var inventory = intValues[j];
          for (var i = 0; i < inventory.length; i++) {
            var data = inventory[i];
            if (!data.shipping_eta) continue;
            if (data.used_stock == 0) continue;
            if (estimateValue <= data.shipping_eta.value) {
              estimatedTime = data.shipping_eta.text;
              estimateValue = data.shipping_eta.value;
            }
          }
        }
      }

      if (estimatedTime) {
        var inventoryMessage = this.env.getConfig(
          "SDBExternalVendorInventory.InventoryMessage"
        );
        return new Handlebars.SafeString(
          Utils.translate(inventoryMessage, estimatedTime)
        );
      }
      return "";
    },
    getContext: function getContext() {
      this.estimatedTime = this.getEstimatedTime();
      return {
        showTitle: !!this.getTitle(),
        title: this.getTitle(),
        estimatedTime: this.estimatedTime,
      };
    },
  });
});
